<template>
  <div>
    <div class="ui grid px-gen m-0 info-bundle py-05">
      <div class="column pl-0">
        <div class="">
          <h3
            class="ui dividing header fdinpro default-header-green is-uppercase"
          >
            Bundle activos
          </h3>
        </div>
        <table class="ui very basic compact table">
          <tbody>
            <tr v-for="(bundle, bindex) in bundles" :key="bindex">
              <td class="five wide">
                <div
                  class="fluid ui button sb-button"
                  v-bind:class="{ active: selected_bundle == bundle }"
                  @click="select_bundle(bundle)"
                >
                  <div class="pre-sb-button">24</div>
                  <div class="name-sb-button">{{ bundle.setup.name }}</div>
                </div>
              </td>
              <td class="five center aligned" v-if="false">
                <button class="ui button ibundle-button-green is-uppercase">
                  Descargar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <graphs ref="graphs" />
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import Graphs from "./report/Graphs";

export default {
  name: "NvidiaTicketNvidiaReportesPais",
  data() {
    return {
      bundles: [],
      selected_bundle: undefined,
      bundle_info: undefined,
    };
  },
  components: { Graphs },
  computed: {},
  mounted() {
    let vm = this;
    vm.init();
  },
  methods: {
    init() {
      let vm = this;
      local_api(this, "post", "/nvidia_bundle/bundle/do-get-list")
        .then((list) => {
          vm.bundles = list;
        })
        .catch((err) => {
          error_toast(err);
        });

      window.jQuery(vm.$refs.rangestart).calendar({
        type: "date",
        endCalendar: window.jQuery(vm.$refs.rangeend),
      });
      window.jQuery(vm.$refs.rangeend).calendar({
        type: "date",
        startCalendar: window.jQuery(vm.$refs.rangestart),
      });
    },
    select_bundle(bundle) {
      let vm = this;
      vm.selected_bundle = bundle;
      local_api(this, "post", "/nworkforce/nvidia/do-get-bundle-info", {
        u: bundle.bundle_id,
      })
        .then((info) => {
          vm.bundle_info = info;

          vm.$refs.graphs.setBundle(info);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    setStores(stores) {
      this.$refs.graphs.setStores(stores);
    },
  },
  watch: {},
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

/*  SPACING   */
.py-05 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.pl-0 {
  padding-left: 0 !important;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

/*  GRAFICAS    */
.charts-nvidia div .is-uppercase {
  background-color: #666666 !important;
  color: white !important;
  padding: 0.5rem 1rem 0.5rem;
}

/* INFORMACION BUNDLE*/
.info-bundle .ten table tbody tr td {
  text-align: center;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .ten table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .ten table tbody tr .six.wide button {
  border-radius: 2rem;
}
.info-bundle .six table tbody tr td {
  text-align: left;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .six table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .six table tbody tr .six.wide button {
  border-radius: 2rem;
}
.ibundle-button-green {
  background-color: #666666 !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.ibundle-button-green.active {
  background-color: #365a0c !important;
}
.ibundle-button-green:hover {
  background-color: #365a0c !important;
}

/*  MODAL FORMS   */
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}

/*  HISTORIAL DE ENVIOS */
.sb-button {
  display: flex !important;
  flex-direction: row;
  text-align: left !important;
  background-color: transparent !important;
  color: #606060 !important;
}
.sb-button:hover {
  color: white !important;
  background-color: #365a0c !important;
}
.sb-button.active {
  color: white !important;
  background-color: #365a0c !important;
}
.pre-sb-button {
  flex: 20%;
}
.name-sb-button {
  flex: 80%;
}
</style>
